var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-list-group',_vm._l((_vm.navlist),function(item){return _c('b-list-group-item',{key:item.index},[_c('b-link',{attrs:{"to":item.link}},[_vm._v(_vm._s(item.title))])],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }